import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import HomeWraper from './page/HomeWraper';
import { Tikets } from './components';
import Wedding1 from './components/Wedding1/Wedding1';
import { useEffect, useState } from 'react';
import HomePage from './components/HomePage/HomePage';
import { customBasesUrlFunc } from './utils/helperFunck';
import { useDispatch, useSelector } from 'react-redux';
import { getProject } from './store/slices/GetProjectSlice/GetProjectApi';
import { selectProjectData } from './store/slices/GetProjectSlice/GetProjectSlice';
import BirthDay from './components/BirthDay/BirthDay';
import NewYear from './components/NewYear/NewYear';
// import BirthDay from './components/Birthday/BirthDay';
function App() {
   const respProjectData = useSelector(selectProjectData);

   const [musicModal, setMusicModal] = useState(false);

   const leng = localStorage.getItem('lang') != null ? localStorage.getItem('lang') : 'am';

   const navigate = useNavigate();

   const { pathname } = useLocation();
   const dispatch = useDispatch();

   useEffect(() => {
      pathname == '/' && navigate(`/${leng}/`);
   }, []);

   useEffect(() => {
      const params = customBasesUrlFunc();
        params?.token && dispatch(getProject(params.token + (params.p_token ? `&p_token=${params.p_token}` : '')));

    }, []);


    
   // document.addEventListener('mousemove', function(e) {
   //    const cursor = document.getElementById('cursor');
   //    cursor.style.left = (e.pageX - 50) + 'px'; 
   //    cursor.style.top = (e.pageY - 20) + 'px'; 
   //  });


   //  document.body.addEventListener('mouseover', function(e) {
   //    e.target.style.fontSize = '1.6rem';
   //    e.target.style.transition = 'all 0.5s ease';
   //  });


    


   //  document.body.addEventListener('mouseout', function(e) {
   //    e.target.style.fontSize = '1rem';
   //    e.target.style.transition = 'all 0.5s ease';

   //  });




   return (
      <div className="App">
         <Routes>
            <Route path="/" element={<HomeWraper />}>
               <Route path=":lang">
               <Route index element={<HomePage/>}/>
                  <Route path="wedding1">
                     <Route index element={<Wedding1 />} />
                  </Route>

                  <Route path="tikets" element={ <div style={{ backgroundColor: 'black' }}> <Tikets /></div>}/>

                  <Route path="tikets" element={
                        <div style={{ backgroundColor: 'black' }}>
                           <Tikets />
                        </div>
                     }
                  />
                  <Route path="birthDay" element={<BirthDay/>} />
                  <Route path="new-year" element={<NewYear/>} />
               </Route>
            </Route>
         </Routes>

         {/* <div id='cursor'></div> */}
      </div>
   );
}

export default App;